'use strict';
import {Component, Inject, Input} from 'ng-metadata/core';
import {beacon, PrimolyticsService} from '../../../analytics/primolytics.service';
import {SavedQueriesService} from '../../../favorites/savedQueries/savedQueries.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";

const flatten= require('lodash/flatten');


@Component({
    selector: 'prm-edit-notification-settings',
    templateUrl: 'components/search/savedQueries/editNotificationSettings/edit-notification-settings.html'
})

export class PrmEditNotificationSettings{
    @Input() public email  : string;
    @Input() public notificationName  : string;
    @Input() public id  : number | Array<number>;
    @Input() public addMode: boolean;
    
    private emailRegEx: RegExp;
    
    constructor(
        @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
        private configurationUtil: ConfigurationUtil,
        private primolyticsService: PrimolyticsService,
        private savedQueriesService:SavedQueriesService) {
        this.emailRegEx = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    }
    
    private saveEmail(){
        if (!this.isFormValid()){
            return;
        }
        let selectedIds= flatten([this.id]);
        this.savedQueriesService.setAlertToSelectedSearches(this.email, this.notificationName, selectedIds)
            .then((res) =>{
                console.log('entire res:' + JSON.stringify(res));
                this.savedQueriesService.getItemsFromApi();//Refreshing the list
                this.addMode ? this.setAlertBeacon() : '';
                this.$mdDialog.hide();
            }, (reason) => {
                console.log('add failed: ',reason);
            });                
    }
    
    private isFormValid(){
        return this.emailRegEx.test(this.email);
    }
    
    get isSuprima() {
        return this.configurationUtil.isSuprima();
    }

    private close(){
        this.$mdDialog.hide();
    }
    
    private setAlertBeacon(){
        this.primolyticsService.doBeaconReport({
            'p': 'myAccount',
            'op': 'setAlert'
        }, this.savedQueriesService.getItemsFromApi(), this.primolyticsService.getTimestamp());    
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/savedQueries/editNotificationSettings/editNotificationSettings.directive.ts